import { PropsWithChildren } from 'react';

import { isConnectedToBeastAtom } from '@realtime';
import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { useWindowFocus } from '@hooks';
import { getActivitySwingsKey, queryClient, queryKeys } from '@queries';
import { currentActivityIdAtom, globalStore, isCurrentActivityAtom, studentIdAtom } from '@store';
import { ScreenTitle, SystemMessageBanner } from '@ui';

import OldActivityTopBar from './OldActivityTopBar';
import * as css from './style.css';

type ActivityLayoutProps = {
    getActivities: (studentId: string | undefined) => string;
    hasConnection?: boolean;
};

const invalidateCurrentActivityCache = () => {
    const currentActivityId = globalStore.get(currentActivityIdAtom);
    queryClient.invalidateQueries({ queryKey: queryKeys.activities.one(currentActivityId) });
    queryClient.invalidateQueries({ queryKey: getActivitySwingsKey(currentActivityId) });
};

const SystemBanner = () => {
    const isConnected = useAtomValue(isConnectedToBeastAtom);
    const isWindowFocused = useWindowFocus({ onFocus: invalidateCurrentActivityCache });
    return (
        !isConnected &&
        isWindowFocused && <SystemMessageBanner message="Disconnected, trying to reconnect..." isVisible />
    );
};

export const ActivityLayout = ({ children, getActivities, hasConnection }: PropsWithChildren<ActivityLayoutProps>) => {
    const isCurrentActivity = useAtomValue(isCurrentActivityAtom);
    const navigate = useNavigate();
    const studentId = useAtomValue(studentIdAtom);
    const navigateBack = () => {
        navigate(getActivities(studentId));
    };

    return (
        <div className={css.root}>
            <ScreenTitle title="ELVA Golf — Activity" />
            {!isCurrentActivity && <OldActivityTopBar onBack={navigateBack} />}
            {hasConnection && <SystemBanner />}
            <div className={css.screen}>{children}</div>
        </div>
    );
};
